<div class="searchable-dropdown">
    <input (click)="selectAll($event)"
           (focus)="this.isListVisible.set(true)"
           [ngModel]="filterValue()"
           (ngModelChange)="onInputChange($event)"
           class="floating-field-cus peer"
           id="cro"
           autocomplete="off"
           placeholder=""
           type="search"
           [disabled]="disabled()"
            />
    @if (isListVisible()) {
        <ul class="list">
            @for (option of cro(); track option) {
                <li class="item" (click)="onOptionSelected(option.employeeId)">
                    {{ option.employeeName }}
                </li>
            }
        </ul>
    }
    <label for="cro" class="floating-lbl">CRO <span class="text-red-700">*</span></label>
</div>
